import { render, staticRenderFns } from "./newPeople.vue?vue&type=template&id=16d7b8a7&scoped=true"
import script from "./newPeople.vue?vue&type=script&setup=true&lang=js"
export * from "./newPeople.vue?vue&type=script&setup=true&lang=js"
import style0 from "./newPeople.vue?vue&type=style&index=0&id=16d7b8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7b8a7",
  null
  
)

export default component.exports